export const TRACKED_PRODUCT_INDEX_BASE = 10;
